import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import SpecialMattressGifs from "../../components/specialMattressGifs";
import SpecialMattressItems from "../../components/specialMattressItems";
import { ISpecialMattressProps } from "../../models/interface/ISpecialMattressProps";
import { sections } from "../../services";
import "./style.scss";
import _ from "lodash";
import {
  SECTION_SPECIAL_MATTRESS,
  SECTION_SPECIAL_MATTRESS_GIFS,
  SECTION_SPECIAL_MATTRESS_ITEMS,
} from "../../common/constant";

const SpecialMattress = (props: ISpecialMattressProps) => {
  const [specialMattressData, setSpecialMattressData] = useState<any>([]);

  useEffect(() => {
    sections.getSections(
      {
        ids: SECTION_SPECIAL_MATTRESS,
      },
      (data: any, err: any) => {
        if (data && data.data && data.data.length) {
          setSpecialMattressData(_.sortBy(data.data, ["order"]));
        }
      }
    );
    window.history.scrollRestoration = "manual";
  }, []);

  const renderSections = (data: any) =>
    data.map((item: any, i: number, row: any) => {
      if (item._id.toString() === SECTION_SPECIAL_MATTRESS_GIFS) {
        return <SpecialMattressGifs {...props} sectionGifs={item} />;
      } else if (item._id.toString() === SECTION_SPECIAL_MATTRESS_ITEMS) {
        return <SpecialMattressItems {...props} sectionItems={item.children} />;
      }
      // } else if (item._id.toString() === SECTION_SPECIAL_MATTRESS_CATEGORIES) {
      //   return (
      //     <SpecialMattressCategories {...props} sectionCategories={item} />
      //   );
    });

  return (
    <div className="kd-special-mattress">
      {specialMattressData.length ? renderSections(specialMattressData) : null}
    </div>
  );
};

export default withTranslation()(SpecialMattress);
